/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_TitleInputs */

const en_cap_promise_title = /** @type {(inputs: Cap_Promise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every system ships with`)
};

const lv_cap_promise_title = /** @type {(inputs: Cap_Promise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katrai sistēmai ir`)
};

/**
* | output |
* | --- |
* | "Every system ships with" |
*
* @param {Cap_Promise_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_title = /** @type {((inputs?: Cap_Promise_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_title(inputs)
	return en_cap_promise_title(inputs)
});